/**
 * Provider Configuration
 * Defines all available cloud providers and their properties
 */

export const PROVIDERS = {
  digitalocean: {
    id: 'digitalocean',
    name: 'DigitalOcean',
    displayName: 'DigitalOcean',
    logo: '/logos/digitalocean.svg',
    color: '#0080FF',
    supportedResources: ['compute', 'storage', 'database', 'network'],
    defaultRegion: 'nyc1',
    enabled: true
  },
  aws: {
    id: 'aws',
    name: 'Amazon Web Services',
    displayName: 'AWS',
    logo: '/logos/aws.svg',
    color: '#FF9900',
    supportedResources: ['compute', 'storage', 'database'],
    defaultRegion: 'us-east-1',
    enabled: false // Enable when AWS provider is added
  },
  azure: {
    id: 'azure',
    name: 'Microsoft Azure',
    displayName: 'Azure',
    logo: '/logos/azure.svg',
    color: '#0089D6',
    supportedResources: ['compute', 'storage', 'database'],
    defaultRegion: 'eastus',
    enabled: false // Enable when Azure provider is added
  }
};

/**
 * Get enabled providers only
 */
export const getEnabledProviders = () => {
  return Object.values(PROVIDERS).filter(p => p.enabled);
};

/**
 * Get provider by ID
 */
export const getProvider = (providerId) => {
  return PROVIDERS[providerId] || null;
};

/**
 * Get provider color
 */
export const getProviderColor = (providerId) => {
  const provider = PROVIDERS[providerId];
  return provider?.color || '#666666';
};

/**
 * Get provider name
 */
export const getProviderName = (providerId) => {
  const provider = PROVIDERS[providerId];
  return provider?.displayName || providerId;
};

/**
 * Check if resource type is supported by provider
 */
export const isResourceSupported = (providerId, resourceType) => {
  const provider = PROVIDERS[providerId];
  return provider?.supportedResources.includes(resourceType) || false;
};

export default PROVIDERS;

